import { createFileRoute } from '@tanstack/react-router';
import { UserProfileById } from '@/features/user-profile';

export const Route = createFileRoute('/_authenticated/id/$id/')({
    head: () => ({ meta: [{ title: 'Profile | promote.fun' }] }),
    component: UserProfileById,
});
